import { useState, useEffect } from 'react';

/**
 * @typedef {{
 * config: any;
 * description: string;
 * field_type: "text" | "number" | "dropdown" | "multiselect" | "checkbox" | "dateonly" | "datetime"
 * label: string;
 * }} FieldDetails
 *
 *
 * @typedef {{
 * field: FieldDetails;
 * field_id: string;
 * field_value: string;
 * item_type: string;
 * }} Field
 *
 *
 * @typedef {{
 * description: string;
 * title: string;
 * items: Array<Field>;
 * }} FieldsData
 *
 * @param {Array<FieldsData>} fieldsData
 * @returns
 */
const parseInitialValues = (fieldsData) => {
  // TODO: move to utils for re-use
  /**
   * @type {Record<string, string>}
   */
  const initialValues = {};

  for (const row of fieldsData) {
    for (const field of row.items) {
      let normalizedValue;

      if (field.field.field_type === 'multiselect') {
        normalizedValue =
          typeof field.field_value === 'string' && field.field_value
            ? field.field_value.split(',')
            : [];
      } else {
        normalizedValue = field.field_value;
      }

      initialValues[field.field_id] = normalizedValue;
    }
  }

  return initialValues;
};

// TODO: maybe remove from there?

/**
 *
 * @param {Array<FieldsData>} fieldsData
 * @returns
 */
export const useFormData = (fieldsData) => {
  const [formData, setFormData] = useState({});
  const [initFieldsData, setInitFieldsData] = useState({});

  useEffect(() => {
    setFormData(parseInitialValues(fieldsData));
    setInitFieldsData(parseInitialValues(fieldsData));
  }, [fieldsData]);

  const resetToInitialData = () => {
    setFormData(initFieldsData);
  };

  return {
    formData,
    initFieldsData,

    setFormData,
    resetToInitialData
  };
};
